import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import {
  Grid,
  Icon,
  Menu,
} from 'semantic-ui-react';
import { Switch, Route, NavLink } from 'react-router-dom';

import { tabs } from './utils';
import './styles.css';

const Settings = (props) => {
  const { t, user, location } = props;
  const { pathname: pagePathname } = location; // && t.key !== 'default'
  const alowedTabs = tabs.filter(tab => (tab.access === 'all' || tab.access.includes(user.role)));
  const defaultTab = alowedTabs[1];
  return (
    <Grid padded>
      <Grid.Row>
        <Menu compact size="tiny">
          {alowedTabs.map((tab) => {
            const {
              key, pathname, title, iconName,
            } = tab;
            const active = pathname === pagePathname || (key === alowedTabs[1].key && pagePathname === '/settings');
            return key !== 'default'
                && (
                <Menu.Item
                  key={key}
                  className={active ? 'tab-active' : ''}
                  active={active}
                  as={NavLink}
                  to={pathname}
                >
                  <div><Icon name={iconName} />{t(title)}</div>
                </Menu.Item>
                );
          })}
        </Menu>
      </Grid.Row>
      <Grid.Row />
      <Grid.Row>
        <Switch>
          {alowedTabs.map((tab) => {
            const {
              key, pathname, render: ComponentToRender,
            } = tab;
            const DefaultRender = defaultTab.render;
            if (key === 'default') {
              return (
                <Route key={key} path={pathname} exact render={() => <DefaultRender />} />
              );
            }
            return <Route key={key} path={pathname} exact render={() => <ComponentToRender />} />;
          })}
        </Switch>
      </Grid.Row>
    </Grid>
  );
};

Settings.propTypes = {
  t: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  user: PropTypes.shape({
    role: PropTypes.string.isRequired,
  }).isRequired,
};

export default translate()(Settings);



// WEBPACK FOOTER //
// ./src/components/Settings/Settings.js